export const installments = [
  {
    id: 'part-1',
    tab: '第一部',
    year: '2018',
    title: '郊外度假屋的那场重逢',
    subtitle: '群像 · 情感线全面铺开',
    synopsis:
      '五位大学时代的老同学在郊外一处度假屋重聚，名义上是追忆青春，实际上每个人都背着各自成年生活里的疲惫与不满。密闭的空间让关系无处躲藏，几条线同时升温，也同时失控。',
    beats: [
      '重逢的寒暄之下，藏着多年没机会说出口的旧日情愫。',
      '酒过几巡，婚姻里的倦怠被一次次搬上桌面，谁也不肯先承认。',
      '有人试图补全当年未完成的暗恋，有人只是想短暂逃离日常。',
      '深夜的独处让试探变成行动，边界被彻底推远。',
    ],
    keySceneTitle: '深夜客厅里的那杯酒',
    keyScene:
      '散场前只剩两个人对着没喝完的酒，所有欲言又止都在那一刻摊开——这是全片情绪最满、也最危险的节点。',
    endingHook:
      '天亮散场，谁都没真正说清发生了什么，但每个人的生活都已经留下裂缝。',
  },
  {
    id: 'part-2',
    tab: '第二部',
    year: '2019',
    title: '以“投资理财”为名的靠近',
    subtitle: '算计 · 讽刺色彩的骗局线',
    synopsis:
      '故事从“重聚”转向“算计”。男主角以投资、理财为名，重新联系上当年的女同学们。这些女同学大多已经嫁作人妇，因丈夫忙于工作而倍感寂寞，恰好成了被精准锁定的对象。',
    beats: [
      '借着叙旧的名义，一步步重新进入她们的日常生活。',
      '花言巧语换来的是信任，也是账户里实实在在的数字。',
      '感情越界的同时，一场蓄谋已久的骗局正在悄悄收网。',
      '当对方开始追问去向，原本温和的关系瞬间绷紧。',
    ],
    keySceneTitle: '从寒暄到转账的一张饭桌',
    keyScene:
      '同桌吃饭的戏最见功力：从客气到交心再到转账，中间只隔着几句“恰到好处”的关心，讽刺意味拉满。',
    endingHook:
      '当信任被兑现成一串数字，被掏空的从来不只是钱包，还有对熟人关系最后的那点天真。',
  },
  {
    id: 'part-3',
    tab: '第三部',
    year: '2020',
    title: '关系网彻底收束',
    subtitle: '代价 · 冷收尾',
    synopsis:
      '系列走到后段，之前埋下的关系与后果开始同时收束。“同学会”这个设定也被推向更冷的结局——曾经最熟悉的人，反而最难体面告别。',
    beats: [
      '旧的关系还没收尾，新的牵连又找上门来。',
      '当初的侥幸，逐一变成必须面对的代价。',
      '有人想体面退场，有人已经退无可退。',
      '熟人社会里的秘密，终究藏不住。',
    ],
    keySceneTitle: '长桌上冷掉的杯盘',
    keyScene:
      '曾经最热闹的那张长桌，最后只剩下冷掉的杯盘。镜头没有台词，却把“人走茶凉”四个字拍得很安静。',
    endingHook:
      '剧情没有给出轻松的答案，只留下一句“早知如此”的回响，把判断交还给观众。',
  },
];

export const episodeNote =
  '以下按系列分部（可理解为“分集 / 回目”）梳理剧情。每一部相对独立，但按顺序观看更容易理解人物关系的变化。';